// Active / Backlog master-detail pane for OrganizePage (lint split).
import {
  DndContext,
  DragOverlay,
  closestCenter,
} from '@dnd-kit/core';
import { Box } from '@mui/material';
import OrganizeSplitPane from '@/features/organize/components/OrganizeSplitPane';
import OrganizeMasterList from '@/features/organize/components/OrganizeMasterList';
import OrganizeDetailPane from '@/features/organize/components/OrganizeDetailPane';
import OrganizeDragOverlay from '@/features/organize/components/OrganizeDragOverlay';
import ErrorBoundary from '@/components/layout/ErrorBoundary';
import { BulkEditModal } from '@/features/tasks';
import { FilterProvider } from '@/features/tasks/context/FilterContext';

export default function OrganizeActiveBacklogView({
  sensors,
  handleDragStart,
  handleDragEnd,
  handleDragCancel,
  setNodeRef,
  masterListTasks,
  selectedTaskIds,
  handleSelectionChange,
  duplicateOrderKeyTaskIds,
  plannedParentIds,
  waitingForParentIds,
  activeTabKey,
  hasActiveFilter,
  selectedTask,
  processedTasks,
  handleCloseDetail,
  updateTask,
  handleTaskDelete,
  isDetailVisible,
  activeItem,
  isBulkEditModalOpen,
  setIsBulkEditModalOpen,
}) {
  return (
    <DndContext
      sensors={sensors}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      onDragCancel={handleDragCancel}
      collisionDetection={closestCenter}
    >
      <FilterProvider>
        <OrganizeSplitPane
          master={
            <Box
              ref={setNodeRef}
              data-testid="master-list-drop-zone"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                minHeight: '100%',
              }}
            >
              <OrganizeMasterList
                tasks={masterListTasks}
                selectedTaskIds={selectedTaskIds}
                onSelectionChange={handleSelectionChange}
                duplicateOrderKeyTaskIds={duplicateOrderKeyTaskIds}
                itemView="master"
                plannedParentIds={plannedParentIds}
                waitingForParentIds={waitingForParentIds}
                tabKey={activeTabKey}
                hasActiveFilter={hasActiveFilter}
              />
            </Box>
          }
          detail={
            selectedTask ? (
              <ErrorBoundary>
                <OrganizeDetailPane
                  task={selectedTask}
                  tasks={processedTasks}
                  onClose={handleCloseDetail}
                  onUpdate={updateTask}
                  onDelete={handleTaskDelete}
                  duplicateOrderKeyTaskIds={duplicateOrderKeyTaskIds}
                  plannedParentIds={plannedParentIds}
                  waitingForParentIds={waitingForParentIds}
                  showCompleted={true}
                />
              </ErrorBoundary>
            ) : null
          }
          detailVisible={isDetailVisible}
          onCloseDetail={handleCloseDetail}
        />
      </FilterProvider>
      <DragOverlay dropAnimation={null}>
        <OrganizeDragOverlay
          activeItem={activeItem}
          duplicateOrderKeyTaskIds={duplicateOrderKeyTaskIds}
          plannedParentIds={plannedParentIds}
          waitingForParentIds={waitingForParentIds}
        />
      </DragOverlay>
      <BulkEditModal
        open={isBulkEditModalOpen}
        onClose={() => setIsBulkEditModalOpen(false)}
        selectedTaskIds={selectedTaskIds}
      />
    </DndContext>
  );
}
